<template>
    <Modal class="popup_content" v-model="nologinShows" width="320" @on-cancel="nologinCancel">
        <div slot="header" class="popup_header_content">
            <span>提示</span>
        </div>
        <div class="popup_head_body">
            <span class="nologinmsg">{{nologintipsmsg}}</span>
        </div>
        <div slot="footer" class="popup_footer_content">
            <Button type="warning" size="large" @click="nologinOk">登录</Button>
        </div>
    </Modal>
</template>

<script>
export default {
    props: ['nologinShow', 'nologintipsmsg'],
    data() {
        return {
            nologinShows: false,
        }
    },
    methods: {
        nologinOk () {
            this.$emit('nologinOk')
            this.$store.dispatch('requireAuthFun', false)
            this.$router.push("/Login")
        },
        nologinCancel () {
            this.$emit('nologinCancel')
        }
    },
    watch: {
        nologinShow () {
            this.nologinShows = this.nologinShow
        }
    }
}
</script>

<style scoped>

.nologinmsg {
    text-align: center;
    font-size: 14px;
    display: block;
}

</style>


// WEBPACK FOOTER //
// src/components/component/popup/nologintips.vue